import { render, staticRenderFns } from "./SaleSettingsView.vue?vue&type=template&id=d8dc954a&scoped=true"
import script from "./SaleSettingsView.vue?vue&type=script&lang=js"
export * from "./SaleSettingsView.vue?vue&type=script&lang=js"
import style0 from "./SaleSettingsView.vue?vue&type=style&index=0&id=d8dc954a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8dc954a",
  null
  
)

export default component.exports